import { useTranslation } from "react-i18next";
import { icAsset } from "../image/image-src";

export const NoResultsWereFound = () => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      <img
        className="mx-auto mb-2 h-16 w-16"
        src={icAsset("../../../assets/icons/search-product-empty.svg")}
        alt=""
      />
      <p className="mb-1 h-[22px] text-center text-base font-semibold leading-[22px] text-[#232323]">
        {t("No results were found")}
      </p>
      <span className="text-center text-sm font-normal leading-[1.1875rem] text-[#BFC5C9]">
        {t("Please enter other keyword")}
      </span>
    </div>
  );
};
